const NOTIFICATION_TYPE = {
    STANDARD: 'standard',
    DETAILED: 'detailed'
};

export default NOTIFICATION_TYPE;